<template>
  <div class="details-center">
    <!-- 顶部的搜索输入框以及按钮 -->
    <div class="details-center-top">
      <!-- <map class="map"></map> -->
      <div ref="myDiv" id="maps" class="homeMap">
        <div class="detail-map" id="detail-map"></div>
        <!-- 切换轨迹时间段 -->
        <div class="history-path-select" v-show="isActive === 0">
          <div class="history-path-flex">
            <el-button size="small" class='history-path-btn' :class="{'history-path-active':range===30}" @click="getPath(30)">30分钟内</el-button>
            <el-button size="small" class='history-path-btn' :class="{'history-path-active':range===1}" @click="getPath(1)">1小时内</el-button>
            <el-button size="small" class='history-path-btn' :class="{'history-path-active':range===2}" @click="getPath(2)">2小时内</el-button>
            <el-button size="small" class='history-path-btn' :class="{'history-path-active':range===4}" @click="getPath(4)">4小时内</el-button>
            <el-button size="small" class='history-path-btn'  @click="getPath(-1)">全部</el-button>
            <el-button size="small" class='history-path-btn'  @click="qp">{{ fullScreenName }}</el-button>
          </div>
        </div>
        <!-- 地图右上方三个tab框选择-->
        <div class="tab">
          <div v-for="(item,index) in 3"
               v-show="protocalType === 5 || index === 0"
               :class="['tab-small','icon'+index]"
               :key="index"
               @click="isActive=index"></div>

          <!--燃油车排放热力-->
          <div @click="isActive= 5"
               v-show="protocalType === 6"
               :class="['tab-small','icon'+ 5]"
          ></div>
          <!--污染物排放热力-->
          <div @click="isActive= 4"
               v-show="protocalType === 6"
               :class="['tab-small','icon'+ 4]"
               ></div>
        </div>
      </div>
    </div>
    <!-- 详情页的底部内容 -->
    <div class="details-center-bottom">
      <div class="details-center-bottom-left001">
        <p class="details-right-name">车内温湿度</p>
        <ak-line :chartData="rightChartData"></ak-line>
      </div>
      <br>
      <div class="details-center-bottom-right001">
        <p class="details-right-name">门锁事件</p>
        <bar :chartData="leftChartData" :dontNeedRightYaxis="true"></bar>
      </div>
    </div>
    <!-- - -->
  </div>
</template>
<script>
import map from './map/map'
import akLine from '@/component/lineDetail'
import bar from '@/component/barDetail.vue'
export default {
  mixins: [map],
  components: {
    akLine,
    bar
  },
  props: {
    vin: {
      type: String,
      default: ''
    },
    protocalType: {
      type: Number
    },
    humidityData: {
      type: Array,
      default () {
        return []
      }
    },
    doorData: {
      type: Array,
      default () {
        return []
      }
    }
  },
  data () {
    return {
      selectData: {
        options: [
          {
            value: '1',
            label: '车牌号'
          },
          {
            value: '2',
            label: 'VIN'
          }
        ],
        value: '1',
        input: ''
      },
      // 控制显示右上角的哪个图标
      isActive: 0,
      // showBar: false,
      barData: [],
      range: -1,
      fullScreenName: '全屏',
      FullScreen: false // 是否全屏
    }
  },
  computed: {
    rightChartData () {
      const data = this.humidityData
      console.log('中下-车内温湿度 1分钟', data)
      let xAxisData = []
      let seriesXL = []
      let seriesXY = []
      data.forEach((item) => {
        let Y = item.tempture.slice(0, 4) || 0
        let Y2 = item.humidity.slice(0, 4) || 0
        xAxisData.push(item.time)
        seriesXL.push(Number(Y))
        seriesXY.push(Number(Y2))
      })
      return {
        yAxis: [{
          type: 'value'
        }],
        xAxisData: xAxisData,
        gradient: true,
        padding: ['15%', '5%', '40%', '8%'],
        color: ['#FFDE68 ', '#00DFFF'],
        colorStops1: ['#FF6C2F88', '#111521', '#111521'],
        colorStops2: ['#00DFFF88', '#111521', '#111521'],
        series: [
          {
            data: seriesXL,
            name: '温度(℃)'
          },
          {
            data: seriesXY,
            name: '湿度(%)'
          }
        ]
      }
    },
    leftChartData () {
      const data = this.doorData
      console.log('中下-门锁事件 1分钟', data)
      let xAxisData = []
      let seriesData = []
      let seriesData2 = []
      data.forEach((item, i) => {
        let y1 = item.open === 1 ? 10 : 0
        let y2 = item.close === 0 ? 10 : 0
        xAxisData.push(item.time)
        seriesData.push(y1)
        seriesData2.push(y2)
      })
      return {
        tooltip: {
          tooltip: {
            trigger: 'axis'
          }
        },
        legend: {
          show: false
        },
        grid: {
          top: '15%',
          right: '5%',
          bottom: '45%',
          left: '5%'
        },
        xAxis: [
          {
            type: 'category',
            data: xAxisData,
            axisPointer: {
              type: 'shadow'
            },
            axisLine: {
              lineStyle: {
                color: '#8794A4'
              }
            },
            axisTick: {
              show: false
            },
            axisLabel: {
              show: true,
              showMaxLabel: true,
              showMinLabel: true,
              interval: 0,
              rotate: 30,
              textStyle: {
                fontSize: 12 // 调整x轴字体大小px
              }
            }
          }
        ],
        yAxis: {
          show: false
        },
        series: [
          {
            name: '关',
            type: 'bar',
            data: seriesData,
            tooltip: {
              formatter: function (params) {
                let str = '关: ' + params.name
                return str
              }
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // var colors = params.value === 10 ? '#1f7be6' : '#ffffff00'
                  return '#1f7be6'
                }
              }
            }
          },
          {
            name: '开',
            type: 'bar',
            data: seriesData2,
            tooltip: {
              formatter: function (params) {
                let str = '开: ' + params.name
                return str
              }
            },
            itemStyle: {
              normal: {
                color: function (params) {
                  // var colors = params.value === 10 ? 'red' : '#ffffff00'
                  return 'red'
                }
              }
            }
          }
        ]
      }
    }
  },
  mounted () {
  },
  methods: {
    getPath (range) {
      this.range = range
      this.$emit('rangeChange', range)
    },

    qp () {
      // let element = document.documentElement;//设置后就是我们平时的整个页面全屏效果
      let element = document.getElementById('maps') // （）填容器需要全屏的id
      if (this.FullScreen) {
        if (document.exitFullscreen) {
          this.fullScreenName = '全屏'
          document.exitFullscreen()
        } else if (document.webkitCancelFullScreen) {
          this.fullScreenName = '全屏'
          document.webkitCancelFullScreen()
        } else if (document.mozCancelFullScreen) {
          this.fullScreenName = '全屏'
          document.mozCancelFullScreen()
        } else if (document.msExitFullscreen) {
          this.fullScreenName = '全屏'
          document.msExitFullscreen()
        }
      } else {
        if (element.requestFullscreen) {
          this.fullScreenName = '还原'
          element.requestFullscreen()
        } else if (element.webkitRequestFullScreen) {
          this.fullScreenName = '还原'
          element.webkitRequestFullScreen()
        } else if (element.mozRequestFullScreen) {
          this.fullScreenName = '还原'
          element.mozRequestFullScreen()
        } else if (element.msRequestFullscreen) {
          // IE11
          this.fullScreenName = '还原'
          element.msRequestFullscreen()
        }
      }
      this.FullScreen = !this.FullScreen
    }
  }
}
</script>
<style lang="scss" scoped>
.details-center {
  font-size: 0.24rem;
  .details-center-top {
    // width: 15.71rem;
    // height: 9.18rem;
    width: 41vw;
    height: 56.2vh;
    margin: 0 0 0 0.28rem;
    background: url("../../../assets/images/bg-gailan-ditu.png") no-repeat;
    background-size: contain;
    .map {
      width: 15.18rem;
      height: 8.63rem;
    }
  }
  .details-center-bottom {
    // width: 15.71rem;
    // height: 4.1rem;
    width: 41vw;
    height: 33.5vh;
    margin: 0.35rem 0 0 0.3rem;
    .details-right-name {
      color: #07e2f2;
      padding-left: 0.1rem;
      padding-top: 0.09rem;
      font-size: 0.28rem;
    }
    .details-center-bottom-left {
      float: left;
      width: 7.73rem;
      height: 5.1rem;
      background: url("../../../assets/images/bg-xiangxi-zhengxia1.png")
        no-repeat;
      background-size: cover;
      box-sizing: border-box;
      position: relative;
      .bard {
        width: 7.73rem;
        height: 5.1rem;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        margin: auto;
      }
    }
    .details-center-bottom-left001 {
      // width: 7.73rem;
      // height: 5.1rem;
      width: 100%;
      height: 17vh;
      background: url("../../../assets/images/bg-xiangxi-zuo001.png")
        no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      position: relative;
      .bard {
        width: 7.73rem;
        height: 5.1rem;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        margin: auto;
      }
    }
    .details-center-bottom-right {
      float: left;
      // width: 7.73rem;
      // height: 5.25rem;
      width: 100%;
      height: 15vh;
      margin: 0 0 0 0.25rem;
      background: url("../../../assets/images/bg-xiangxi-zhengxia02.png")
        no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      position: relative;
      .bard {
        width: 7.73rem;
        height: 5.25rem;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        margin: auto;
      }
    }
    .details-center-bottom-right001 {
      margin-top: 2vh;
      width: 100%;
      height: 17vh;
      margin: 0;
      background: url("../../../assets/images/bg-xiangxi-zuo001.png")
        no-repeat;
      background-size: 100% 100%;
      box-sizing: border-box;
      position: relative;
      .bard {
        width: 7.73rem;
        height: 5.25rem;
        position: absolute;
        top: 0px;
        left: 0px;
        right: 0px;
        bottom: 0px;
        margin: auto;
      }
    }
  }
}
</style>
<style lang="scss" scoped>
$color-name: red green orange;
.homeMap {
  width: 100%;
  height: 100%;
  position: relative;
  overflow: hidden;
  .detail-map {
    height: calc(100% + 50px);
  }
  .search {
    position: absolute;
    top: 0.72rem;
    left: 0.54rem;
    display: flex;
  }
  .history-path-select {
    position: absolute;
    top: 0.8rem;
    left: 0.54rem;
    display: flex;
  }
  .history-path-flex {
    display: flex;
    justify-content: space-around;
  }
  .history-path-btn {
    border-left: 1px solid rgba(39, 227, 255, 0.45) !important;
    padding: 9px 5px;
  }
  .history-path-active {
    border-width: 3px;
    border-left: 3px solid rgba(39, 227, 255, 0.45) !important;
    background: rgba(39, 227, 255, 1) !important;
    text-align: center;
    color: #000001;
    font-weight: 700;
  }
  .tab {
    display: flex;
    position: absolute;
    top: 0.72rem;
    right: 0.54rem;
    .tab-small {
      width: 0.92rem;
      height: 0.7rem;
      margin-left: 0.2rem;
      cursor: pointer;
    }
    @for $i from 0 through 2 {
      .icon#{$i} {
        background: url("../../../assets/images/home/small-0#{$i+1}.png")
        no-repeat;
        background-size: 100% 100%;
        &.active {
          background: url("../../../assets/images/home/selected-0#{$i+1}.png")
          no-repeat;
          background-size: 100% 100%;
        }
      }
      .icon4 {
        background: url("../../../assets/images/home/small-05.png")
        no-repeat;
        background-size: 100% 100%;
      }
      .icon5 {
        background: url("../../../assets/images/home/small-04.png")
        no-repeat;
        background-size: 100% 100%;
      }
    }
  }
}
</style>

<style lang="scss">
.homeMap {
  .el-select {
    width: 2.3rem;
    text-align: center;
  }
  .el-input__inner {
    width: 2.3rem;
    height: 0.7rem;
    line-height: 0.7rem;
    background: rgba(39, 227, 255, 0.3);
    border: 1px solid rgba(39, 227, 255, 0.45);
    font-size: 0.3rem;
    color: #d7e9f2;
    border-radius: 0;
  }
  .el-select .el-input .el-select__caret {
    line-height: 0.7rem;
  }
  .search-input {
    .el-input__inner {
      width: 3rem;
      border: 1px solid rgba(39, 227, 255, 0.45);
      background: rgba(39, 227, 255, 0.1);
      border-left: 0;
    }
  }
  .el-select-dropdown {
    width: 2.3rem;
  }
  .el-button {
    height: 0.7rem;
    line-height: 0.2rem;
    width: 1.5rem;
    border-radius: 0;
    background: rgb(29, 49, 52);
    border: 1px solid rgba(39, 227, 255, 0.45);
    border-left: 0;
    color: #d7e9f2;
    font-size: 0.3rem;
  }
  .el-select:hover .el-input__inner {
    border: 1px solid rgba(39, 227, 255, 0.45);
  }
}
.el-select-dropdown__item {
  height: 0.7rem;
  line-height: 0.7rem;
  font-size: 0.3rem;
}
.el-select-dropdown__list {
  padding: 0.3rem 0 0.5rem 0;
}
.history-map {
  font-size: 0.24rem;
  color: #07E2F2;
  margin-left: 0.15rem;
  margin-top: 0.15rem;
  cursor:pointer;
}
</style>
